import type { ReactNode } from 'react';
import { Center, Loader } from '@mantine/core';
import { Navigate } from '@tanstack/react-router';
import { useAuth } from '../lib/auth';

export function AuthGuard({ children }: { children: ReactNode }) {
  const { isLoading, isAuthenticated } = useAuth();
  if (isLoading) {
    return (
      <Center h="100vh">
        <Loader />
      </Center>
    );
  }
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return <>{children}</>;
}
